import { createFileRoute } from '@tanstack/react-router';

import { clearCachedOrgContext } from '../../components/shared/authentication/orgResolution';
import { getAppOrigin } from '../../components/shared/authentication/orgSubdomain';
import { clearCacheForLogout } from '../../components/shared/utilities/appUtilities';

export const Route = createFileRoute('/_authenticated/logout')({
  beforeLoad: async ({ context }) => {
    const { auth0, apolloClient } = context;
    const clientId = import.meta.env.REACT_APP_AUTH0_CLIENT_ID;

    await clearCacheForLogout(apolloClient);
    // start the next login with a fresh org resolution
    clearCachedOrgContext();

    // perform logout with appropriate app redirect (if populated);
    await auth0.logout({
      clientId,
      logoutParams: {
        returnTo: `${getAppOrigin()}/login`,
      },
    });
  },
});
